import { history } from 'store/rootReducer';

export class IdleTimer {
    private _maxIdleMinutes: number;
    /** The unix timestamp at which the user session times out. */
    private _timeout: number;
    private _paused: boolean;

    private static readonly ACTIVITY_EVENTS = [
        'mousemove',
        'keydown',
        'wheel',
        'mousedown',
        'touchstart',
        'touchmove',
        'visibilitychange',
    ];

    constructor(maxIdleMinutes: number) {
        this._maxIdleMinutes = maxIdleMinutes;
        this._timeout = 0;
        this._paused = false;
        this.resetTimeout = this.resetTimeout.bind(this);
        this._onActivity = this._onActivity.bind(this);
        this.resetTimeout();

        history.listen(() => {
            this._onActivity();
        });

        IdleTimer.ACTIVITY_EVENTS.forEach((event) => {
            document.addEventListener(event, this._onActivity, { passive: true });
        });
    }

    private _onActivity() {
        if (!this._paused) {
            this.resetTimeout();
        }
    }

    pause() {
        this._paused = true;
    }

    resume() {
        this._paused = false;
    }

    resetTimeout() {
        this._timeout = this._maxIdleMinutes * 60 * 1000 + new Date().getTime();
    }

    getRemainingSeconds() {
        return Math.floor((this._timeout - new Date().getTime()) / 1000);
    }
}

export const idleTimer = new IdleTimer(10);
